import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import axios from "axios";
import VueCookies from 'vue-cookies'
import cookie from "vue-cookies";
import moment from 'moment-timezone'
import VueI18n from 'vue-i18n'

Vue.config.productionTip = false

VueCookies.config('30D')

moment.tz.setDefault('Europe/Helsinki')
moment.locale('fi')

axios.interceptors.request.use(
    (config) => {
        let token = cookie.get("token")
        if (token) {
            config.headers['Authorization'] = `Bearer ${ token }`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        console.log('Backend: 401 - Authorization required')
        store.dispatch('resetToken')
        // store.dispatch('createSession')
    } else if (error.response.status === 403) {
        console.log('Backend: 403 - Access forbidden')
        store.dispatch('resetToken')
        // store.dispatch('createSession')
    } else {
        console.log('Error with request: ' + error.code + ' - ' + error.message)
    }
    return error;
});

Vue.use(VueI18n)

const numberFormats = {
    fi: {
        currency: {
            style: "currency",
            currency: "EUR",
            currencyDisplay: "symbol"
        }
    }
};

const i18n = new VueI18n({
    numberFormats
})

new Vue({
    router,
    store,
    VueCookies,
    i18n,
    render: h => h(App),
}).$mount('#app')
